import LeadIntroClickthroughPage from 'registration/lead/intro/LeadIntroClickthroughPage';
import LeadIntroLoadingPage from 'registration/lead/intro/LeadIntroLoadingPage';
import React, { useEffect } from 'react';

const DEFAULT_PATH = 'C';

const PATH_TO_PAGE_MAP = {
  A: LeadIntroLoadingPage,
  B: LeadIntroClickthroughPage,
  C: LeadIntroLoadingPage,
  D: LeadIntroLoadingPage,
  E: LeadIntroClickthroughPage
};

const PATHS_WITH_COBRANDING = ['A', 'B'];

function LeadIntro() {
  const partnerData = window.AppConfig.partner_data || {};
  const landingPath = (partnerData.landing_path || DEFAULT_PATH).toUpperCase();
  const partnerId = partnerData.id;
  const partnerName = partnerData.partner_name;
  const partner = window.AppConfig.partner || {};

  const Page = PATH_TO_PAGE_MAP[landingPath];
  const showCobranding = PATHS_WITH_COBRANDING.includes(landingPath);

  useEffect(() => {
    window.postHeapAnalytic('track', '[lead_intro][view]', {
      incoming_url: partner.incoming_url,
      lead_id: partner.lead_id,
      origination_id: window.AppConfig.origination_id,
      partner_id: partnerId,
      path_version: landingPath
    });
  }, []);

  return (
    <Page
      partnerId={partnerId}
      partnerName={partnerName}
      showCobranding={showCobranding}
    />
  );
}

export default LeadIntro;
